import React from 'react'
import TextImageRowCui from '../TextImageRowCui'

interface InfoProps {
  image: string
  title: string
  text: string
  reverse: boolean
  isNewLandingEnabled: boolean
}

const Info: React.FC<InfoProps> = ({
  image,
  title,
  text,
  reverse,
  isNewLandingEnabled
}) => (
  <div className={`infoSection ${isNewLandingEnabled ? 'newLanding' : ''}`}>
    <TextImageRowCui
      image={image}
      reverse={reverse}
      alt=""
      className={isNewLandingEnabled ? 'newLanding' : ''}
      videoUrlH264=""
      videoPoster=""
      reverseMobile={isNewLandingEnabled}
      black={false}
      autoPlay={false}>
      <p className="rebrand lead">{title}</p>
      <p className="rebrand" dangerouslySetInnerHTML={{ __html: text }} />
    </TextImageRowCui>
  </div>
)

export default Info
